import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import styles from './styles.module.scss';

const SectionLayout = ({ children, theme, gutter, blockGutter }) => {
	const sectionCx = cx(
		styles[`theme_${theme}`],
		styles[`gutter_${gutter}`],
		styles[`blockGutter_${blockGutter}`]
	);

	return (
		<div className={sectionCx}>
			{React.Children.map(
				children,
				(block) =>
					block && (
						<div className={styles.block} key={block.key}>
							{block}
						</div>
					)
			)}
		</div>
	);
};

SectionLayout.propTypes = {
	children: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.node),
		PropTypes.node
	]).isRequired,
	theme: PropTypes.oneOf(['light']),
	blockGutter: PropTypes.oneOf(['compact']),
	gutter: PropTypes.oneOf(['bottom', 'full', 'medium', 'largeFull', 'small'])
};

export default SectionLayout;

export { default as Element } from './components/Element';
